import React, { useEffect, useState } from "react";
import moment from "moment";
import store from "../../store/Store";
import CreateNewSchedule from "../common/CreateNewSchedule";
import UploadTransporterData from "../common/upload-new-data/UploadTransporterData";
import TransporterDataTable from "../common/tables/TransporterDataTable";
import { exportData } from "../../utils/helpers";
import {
	getTransporterData,
	getCarrierwiseContainerCount,
} from "../../services/TransporterDataService";
import MaerskTransporterExcelData from "../../assets/ExcelData/MaerskTransporterExcelData.json";
import HapagTransporterExcelData from "../../assets/ExcelData/HapagTransporterExcelData.json";
import TransporterExcelUploadTemplate from "../../assets/ExcelData/TransporterExcelUploadTemplate.json";
import { filter } from "lodash";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import { dispatcher } from "../../store/storeHelpers";
import * as actionTypes from "../../store/ActionTypes";
import Counters from "../common/Counters";
import { formatCarrierwiseContainerCount } from "../../utils/dataFilter";
import { PulseLoader } from "react-spinners";

function TransporterData() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [date, setDate] = useState({
    fromdate:moment().format("YYYY-MM-DD"),
    todate:moment().format("YYYY-MM-DD"),
  });
  const [showCreateNewSchedule, setShowCreateNewSchedule] = useState(false);
  const [showDailyPlanUploader, setShowDailyPlanUploader] = useState(false);
  // const [newSelectedFlatRows, setNewSelectedFlatRows] = useState([]);
  const [userData, setUserData] = useState([])
  const [filteredUserAccessData, setFilteredUserAccessData] = useState([])
  // const [copyData, setCopyData] = useState([])
  const [noDataState, setNoDataState] = useState(false)
  const [carrierList, setCarrierList] = useState({})

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().transporter_data));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "Transporter", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Transporter", View: 1 })
			);
		}
	}, [userData]);
	//  useEffect(()=>{
	//   if(copyData.length > 0){
	//     setData(copyData)
	//   }
	//  },[copyData])
	const resetStorage = () => {
		setData([]);
	};

	useEffect(() => {
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				const response = await getTransporterData(date);
				dispatcher(actionTypes.TRANSPORTER_LOADING, response);
				setData(response);
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
				}
			}
		}
		getPlan();
	}, [date]);

	useEffect(() => {
		async function carrierwiseContainerCount() {
			try {
				const response = await getCarrierwiseContainerCount(date);
				setCarrierList(formatCarrierwiseContainerCount(response.data));
			} catch (error) {
				setCarrierList({})
			}
		}
		carrierwiseContainerCount();
	}, [date]);
	const dataExportHandler = () => {
		exportData(
			data.map((item) => {
				return {
					Date: item["Date"] === "Invalid date" ? "" : item["Date"],
					Module: item["DataOf"],
					Vehicle_No: item["Vehicle_No"],
					FLEETX_LR_No: item["FLEETX_LR_No"],
					Customer: item["Customer"],
					Booking_Number: item["Booking_Number"],
					Container_Number: item["Container_Number"],
					Container_Type: item["Container_Type"],
					Carrier: item["Carrier"],
					Consignee: item["Consignee"],
					Consignee_name: item["Consignee_name"],
					Clearance: item["Clearance"],
					Empty_yard: item["Empty_yard"],
					Movement_type: item["Movement_type"],
					Seal_No: item["Seal_No"],
					Driver_No: item["Driver_No"],
				};
			}),
			`Transporter Data Plan ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	const transporterUploadTemplateFileExportHandler = () => {
		exportData(
			TransporterExcelUploadTemplate,
			`Universal Transporter Excel Template ${moment(date).format(
				"DD-MM-YYYY"
			)}`
		);
	};

	const maerskTemplateFileExportHandler = () => {
		exportData(
			MaerskTransporterExcelData,
			`Maersk Transporter Excel Template ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	const hapagTemplateFileExportHandler = () => {
		exportData(
			HapagTransporterExcelData,
			`Hapag Transporter Excel Template ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>Transporter</h1>
				<Counters
					counter={carrierList}
					label={Object.keys(carrierList)}
					styleData="df_transporterCounter"
				/>
			</div>
			<CreateNewSchedule
				show={showCreateNewSchedule}
				handleClose={() => setShowCreateNewSchedule(false)}
			/>
			{showDailyPlanUploader && <UploadTransporterData
				show={showDailyPlanUploader}
				handleClose={() => setShowDailyPlanUploader(false)}
				setData={setData}
				setNoDataState={setNoDataState}
				date={date}
				setDate={setDate}
				setCarrierList={setCarrierList}
			/>}

			{loader && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}
			{!loader && noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					className="noDataFoundImg"
					// style={{marginLeft:"-2%"}}
				/>
			)}
			{!loader && (
				<TransporterDataTable
					tableData={data}
					date={date}
					setDate={setDate}
					setShowCreateNewSchedule={setShowCreateNewSchedule}
					setShowDailyPlanUploader={setShowDailyPlanUploader}
					dataExportHandler={dataExportHandler}
					subModule="Daily"
					type={"Daily"}
					// newSelectedFlatRows={newSelectedFlatRows}
					// setNewSelectedFlatRows={setNewSelectedFlatRows}
					maerskTemplateFileExportHandler={maerskTemplateFileExportHandler}
					hapagTemplateFileExportHandler={hapagTemplateFileExportHandler}
					transporterUploadTemplateFileExportHandler={
						transporterUploadTemplateFileExportHandler
					}
					filteredUserAccessData={filteredUserAccessData}
					// setCopyData={setCopyData}
					noDataState={noDataState}
					setNoDataState={setNoDataState}
					setCarrierList={setCarrierList}
				/>
			)}
		</>
	);
}

export default TransporterData;
